import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils4.js';
import { d as defineCustomElement$5 } from './custom-popper2.js';
import { d as defineCustomElement$4 } from './form-control-error-text2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const IdentityAddressForm = /*@__PURE__*/ proxyCustomElement(class IdentityAddressForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            this.address[name] = value;
            this.address = Object.assign({}, this.address);
        };
        this.handleFormUpdate = undefined;
        this.errors = undefined;
        this.defaultValues = undefined;
        this.address = {};
    }
    handleAddressChange(newValues) {
        this.handleFormUpdate(newValues);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (h(Host, { key: 'd090676d3bb1d9de9ae947ff25d94b5985ace914', exportparts: "label,input,input-invalid" }, h("div", { key: '64ddec6db508d27b709ad551f60fe58494631fe3', class: "row gy-3" }, h("div", { key: '7e0f89b7b8d5a466b89efad75498c5d1f2cac8ea', class: "col-12 col-md-8" }, h("form-control-text", { key: '0fdbbf48001fe60c5bf5e7a07d7b43186ca2f0eb', name: "line1", label: "Street Address", defaultValue: (_a = this.defaultValues) === null || _a === void 0 ? void 0 : _a.line1, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line1, inputHandler: this.inputHandler, helpText: "\u200B\u200BEnter your address exactly as stated on your driver's license. No PO Boxes." })), h("div", { key: '2b17a0fcd80dbea0703ac0291d5e509b0c14d9c8', class: "col-12 col-md-4" }, h("form-control-text", { key: 'ae29fceaf3af789789c86f545dab6a9d0e4c8429', name: "line2", label: "Apartment, Suite, etc. (optional)", defaultValue: (_c = this.defaultValues) === null || _c === void 0 ? void 0 : _c.line2, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.line2, inputHandler: this.inputHandler })), h("div", { key: '55ccf8053ec8e3c1f4534c47d8d23eeac3383d13', class: "col-12" }, h("form-control-text", { key: '3a3ca85cbf0514da6828e3f5a0bf0fd4b9e983c8', name: "city", label: "City", defaultValue: (_e = this.defaultValues) === null || _e === void 0 ? void 0 : _e.city, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.city, inputHandler: this.inputHandler })), h("div", { key: 'daf6e6031b8dfab6a3e0170f96cc2f0649ded7ce', class: "col-12 col-md-6" }, h("form-control-select", { key: '08791966d72817826f23c3d55ffe3cbaad0ac3bd', name: "state", label: "State", defaultValue: (_g = this.defaultValues) === null || _g === void 0 ? void 0 : _g.state, options: StateOptions, errorText: (_h = this.errors) === null || _h === void 0 ? void 0 : _h.state, inputHandler: this.inputHandler })), h("div", { key: 'c97882ae4c598f762ec32e9ff54b819077ba7193', class: "col-12 col-md-6" }, h("form-control-text", { key: '562ffc8ad8de252d009a284b7b61f978084034dd', name: "postal_code", label: "Postal Code", defaultValue: (_j = this.defaultValues) === null || _j === void 0 ? void 0 : _j.postal_code, errorText: (_k = this.errors) === null || _k === void 0 ? void 0 : _k.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler, inputHandler: this.inputHandler })), h("div", { key: '6fda38b6ab0618bd9c47ae51417f3b7e10148f53', class: "col-12" }, h("form-control-select", { key: 'df9ec4209e2c82ba05af0160cb74849c20110bae', name: "country", label: "Country", options: [{ label: 'United States', value: 'USA' }], inputHandler: this.inputHandler, defaultValue: (_l = this.defaultValues) === null || _l === void 0 ? void 0 : _l.country, errorText: (_m = this.errors) === null || _m === void 0 ? void 0 : _m.country,
            // just for now so we skip handling country specificities
            disabled: true })))));
    }
    static get watchers() { return {
        "address": ["handleAddressChange"]
    }; }
}, [0, "justifi-identity-address-form", {
        "handleFormUpdate": [16],
        "errors": [8],
        "defaultValues": [8, "default-values"],
        "address": [32]
    }, undefined, {
        "address": ["handleAddressChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-identity-address-form", "custom-popper", "form-control-error-text", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, IdentityAddressForm);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { IdentityAddressForm as I, defineCustomElement as d };
